import { Flex, FormItem, Icon, Spacing, Text, ToggleGroup, ToggleGroupItem, Tooltip } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { EntityType } from '../../enums/entityType'

interface EInvoiceAddressEntityTypeToggleProps {
  entityType?: EntityType
  handleEntityTypeChange: (entityType: EntityType) => void
}

export const EInvoiceAddressEntityTypeToggle = ({
  entityType,
  handleEntityTypeChange,
}: EInvoiceAddressEntityTypeToggleProps): ReactElement => {
  const { t } = useTranslation()

  const entityTypeItems: ToggleGroupItem[] = useMemo(
    () => [
      {
        value: EntityType.Private,
        label: t('customer_modal.form.entity_type_toggle.private.label'),
      },
      {
        value: EntityType.Public,
        label: t('customer_modal.form.entity_type_toggle.public.label'),
      },
    ],
    [t],
  )

  return (
    <FormItem
      itemColumnStart={1}
      itemColumnEnd={8}
      label={
        <Flex flexDirection="row" gap={Spacing.S4}>
          <Text colorVariant="secondary">{t('customer_modal.form.entity_type_toggle.label')}</Text>
          <Tooltip
            label={<Trans i18nKey="customer_modal.form.entity_type_toggle.tooltip.label" components={{ br: <br /> }} />}
            placement="top"
          >
            <Icon icon="circleQuestionMark" size="xs" />
          </Tooltip>
        </Flex>
      }
    >
      <ToggleGroup
        defaultValue={EntityType.Private}
        items={entityTypeItems}
        onChange={(event) => {
          const value = event.currentTarget.value as EntityType
          handleEntityTypeChange(value)
        }}
        value={entityType}
      />
    </FormItem>
  )
}
